export const Refresh = () => {
  window.location.reload(false);
};
